var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMedicaltestLoading(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 319.103,
    height: 306.574,
    viewBox: "0 0 319.103 306.574",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Waiting-for-prescrib-test-02",
    transform: "translate(-20.15 -33.18)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Character",
    transform: "translate(20.15 33.18)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_377",
    "data-name": "Rectangle 377",
    width: 27.995,
    height: 59.753,
    transform: "translate(0 55.21)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_378",
    "data-name": "Rectangle 378",
    width: 30.25,
    height: 59.753,
    transform: "translate(29.073 55.21)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_379",
    "data-name": "Rectangle 379",
    width: 30.25,
    height: 57.73,
    transform: "translate(29.073 119.142)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2872",
    "data-name": "Path 2872",
    d: "M112.73,87.359h31.857v-53h1.078v53h25.919V33.18H112.73Z",
    transform: "translate(-51.516 -33.18)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_380",
    "data-name": "Rectangle 380",
    width: 25.926,
    height: 59.753,
    transform: "translate(94.149 55.21)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_381",
    "data-name": "Rectangle 381",
    width: 25.926,
    height: 57.73,
    transform: "translate(94.149 119.142)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_382",
    "data-name": "Rectangle 382",
    width: 27.995,
    height: 57.73,
    transform: "translate(0 119.142)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_383",
    "data-name": "Rectangle 383",
    width: 31.857,
    height: 57.73,
    transform: "translate(61.214 119.142)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_384",
    "data-name": "Rectangle 384",
    width: 27.995,
    height: 52.023,
    transform: "translate(0 177.903)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_385",
    "data-name": "Rectangle 385",
    width: 25.926,
    height: 52.023,
    transform: "translate(94.149 177.903)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2873",
    "data-name": "Path 2873",
    d: "M48.145,87.359v-53h1.078v53H79.467V33.18H20.15V87.359Z",
    transform: "translate(-20.15 -33.18)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_386",
    "data-name": "Rectangle 386",
    width: 31.857,
    height: 52.023,
    transform: "translate(61.214 177.903)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_387",
    "data-name": "Rectangle 387",
    width: 30.25,
    height: 52.023,
    transform: "translate(29.073 177.903)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_388",
    "data-name": "Rectangle 388",
    width: 31.857,
    height: 59.753,
    transform: "translate(61.214 55.21)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2874",
    "data-name": "Path 2874",
    d: "M308.951,346.45,306.2,445.888H429.138V347.805Z",
    transform: "translate(-117.063 -139.315)",
    fill: "#f4f4f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2875",
    "data-name": "Path 2875",
    d: "M422.31,353.98l-.82,74.035h41.3V354.43Z",
    transform: "translate(-156.123 -141.866)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2876",
    "data-name": "Path 2876",
    d: "M351.95,357.49v32.789h43.7V359.037Z",
    transform: "translate(-132.563 -143.055)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2877",
    "data-name": "Path 2877",
    d: "M346.56,370.158v6.453h17.819V369.57Z",
    transform: "translate(-130.737 -147.148)",
    fill: "#f4f4f4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_389",
    "data-name": "Rectangle 389",
    width: 18.401,
    height: 2.645,
    transform: "translate(215.823 234.899)",
    fill: "#f4f4f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2878",
    "data-name": "Path 2878",
    d: "M351.95,413.39v32.789h43.7V414.937Z",
    transform: "translate(-132.563 -161.994)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2879",
    "data-name": "Path 2879",
    d: "M346.56,444.678v6.453h17.819V444.09Z",
    transform: "translate(-130.737 -172.395)",
    fill: "#f4f4f4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_390",
    "data-name": "Rectangle 390",
    width: 18.401,
    height: 2.645,
    transform: "translate(215.823 284.165)",
    fill: "#f4f4f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2880",
    "data-name": "Path 2880",
    d: "M397.55,67.432h-1.666V64.278a1.759,1.759,0,0,0-1.66-1.851H381.562a1.752,1.752,0,0,0-1.666,1.845h0v3.154h-1.666V64.278a3.425,3.425,0,0,1,3.306-3.518h12.675a3.425,3.425,0,0,1,3.306,3.518h0Z",
    transform: "translate(-141.466 -42.524)",
    fill: "#e9e9e9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_391",
    "data-name": "Rectangle 391",
    width: 65.585,
    height: 43.851,
    rx: 7.67,
    transform: "translate(213.509 24.908)",
    fill: "#e9e9e9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_392",
    "data-name": "Rectangle 392",
    width: 3.934,
    height: 17.621,
    transform: "translate(244.467 37.98)",
    fill: "#f4f4f4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_393",
    "data-name": "Rectangle 393",
    width: 17.621,
    height: 3.934,
    transform: "translate(237.623 44.823)",
    fill: "#f4f4f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2881",
    "data-name": "Path 2881",
    d: "M399.9,96.411a.887.887,0,0,1,0-.231,6.877,6.877,0,0,0-.053-.7,2.851,2.851,0,0,0-.033-.509c-.033-.185-.059-.39-.093-.615a12.97,12.97,0,0,0-.311-1.508,14.2,14.2,0,0,0-1.64-3.888A14.546,14.546,0,0,0,380.3,82.75a13.739,13.739,0,0,0-3.676,1.984,16.835,16.835,0,0,0-1.666,1.4,16.294,16.294,0,0,0-1.448,1.679,14.48,14.48,0,0,0-2.076,13.178A13.918,13.918,0,0,0,373.508,105a16.294,16.294,0,0,0,1.422,1.666,17.639,17.639,0,0,0,1.666,1.4,14.946,14.946,0,0,0,1.792,1.144,14.15,14.15,0,0,0,1.891.833,14.6,14.6,0,0,0,17.5-6.2,14.229,14.229,0,0,0,1.633-3.881,11.9,11.9,0,0,0,.311-1.521,5.125,5.125,0,0,1,.093-.608c.02-.185,0-.357.033-.509,0-.3.04-.529.053-.7a.969.969,0,0,1,0-.238,1.432,1.432,0,0,1,0,.238v1.217a4.952,4.952,0,0,1-.086.622,10.015,10.015,0,0,1-.284,1.527,13.839,13.839,0,0,1-1.6,3.967,14.811,14.811,0,0,1-9.931,7,15.022,15.022,0,0,1-9.726-1.474,15.491,15.491,0,0,1-1.825-1.164,13.885,13.885,0,0,1-3.121-3.147,14.233,14.233,0,0,1-2.122-4.086,15.709,15.709,0,0,1-.767-4.688,15.869,15.869,0,0,1,.767-4.688,14.235,14.235,0,0,1,2.122-4.086,16.708,16.708,0,0,1,1.382-1.673,17.923,17.923,0,0,1,1.673-1.441,16.452,16.452,0,0,1,1.825-1.17,14.4,14.4,0,0,1,1.937-.84,14.745,14.745,0,0,1,17.773,6.367,14.051,14.051,0,0,1,1.607,3.967,10.011,10.011,0,0,1,.278,1.527c.033.225.066.43.086.615a4.575,4.575,0,0,1,0,.522v.7A1.07,1.07,0,0,1,399.9,96.411Z",
    transform: "translate(-138.827 -49.584)",
    fill: "#f4f4f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2882",
    "data-name": "Path 2882",
    d: "M467.146,72.342V65.73h-4.661v6.612H457.79v37.927H471.5V72.342Z",
    transform: "translate(-168.421 -44.208)",
    fill: "#e9e9e9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_394",
    "data-name": "Rectangle 394",
    width: 113.145,
    height: 5.772,
    transform: "translate(205.958 66.061)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_395",
    "data-name": "Rectangle 395",
    width: 3.293,
    height: 13.647,
    transform: "translate(228.069 71.833)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_396",
    "data-name": "Rectangle 396",
    width: 3.293,
    height: 13.647,
    transform: "translate(293.951 71.833)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2883",
    "data-name": "Path 2883",
    d: "M429.843,88.677V83.83h-3.412v4.847H423V116.4h10.024V88.677Z",
    transform: "translate(-156.634 -50.34)",
    fill: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2884",
    "data-name": "Path 2884",
    d: "M447.057,88.677V83.83h-3.412v4.847H440.22V116.4h10.024V88.677Z",
    transform: "translate(-162.468 -50.34)",
    fill: "#f4f4f4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_397",
    "data-name": "Rectangle 397",
    width: 18.011,
    height: 18.011,
    transform: "translate(210.058 48.043)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2885",
    "data-name": "Path 2885",
    d: "M355.893,112.742c0,.112-3.967.212-8.887.212s-8.887-.1-8.887-.212,3.967-.212,8.887-.212S355.893,112.623,355.893,112.742Z",
    transform: "translate(-127.877 -60.064)",
    fill: "#e9e9e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2886",
    "data-name": "Path 2886",
    d: "M288.575,107.624h.212a1.878,1.878,0,0,1,.615.291,3.306,3.306,0,0,1,1.283,2.156,4.886,4.886,0,0,1-.608,3.663,3.366,3.366,0,0,1-1.805,1.369,4.424,4.424,0,0,1-2.42,0,4.318,4.318,0,0,1-3.24-3.114,3.637,3.637,0,0,1,2.711-4.364,3.194,3.194,0,0,1,.707-.093,1.508,1.508,0,0,1,.9.145,7.137,7.137,0,0,1-.886.066,3.663,3.663,0,0,0-2.07,1.005,3.359,3.359,0,0,0-.873,3.128,3.848,3.848,0,0,0,2.87,2.7,3.967,3.967,0,0,0,2.156,0,2.889,2.889,0,0,0,1.554-1.15,4.562,4.562,0,0,0,.628-3.306,3.306,3.306,0,0,0-1.025-2.05A3.484,3.484,0,0,0,288.575,107.624Z",
    transform: "translate(-109.039 -58.365)",
    fill: "#e9e9e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2887",
    "data-name": "Path 2887",
    d: "M318,478.852c0,.1-63.37.172-141.5.172S35,478.951,35,478.852s63.357-.172,141.531-.172S318,478.759,318,478.852Z",
    transform: "translate(-25.181 -184.114)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_398",
    "data-name": "Rectangle 398",
    width: 172.687,
    height: 228.082,
    rx: 10.1,
    transform: "translate(72.779 2.638)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_399",
    "data-name": "Rectangle 399",
    width: 149.558,
    height: 201.634,
    transform: "translate(84.337 13.416)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2888",
    "data-name": "Path 2888",
    d: "M297.2,254.989c0-1.375-.066-82.247-.159-201.667l.159.152H147.655l.172-.172V254.969l-.145-.145,149.564.145-149.564.139h-.139v-.139c0-56.758,0-126.435-.033-201.667V53.13H297.4v.159C297.266,172.722,297.2,253.613,297.2,254.989Z",
    transform: "translate(-63.299 -39.939)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_400",
    "data-name": "Rectangle 400",
    width: 16.92,
    height: 6.354,
    transform: "translate(103.399 32.935)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2889",
    "data-name": "Path 2889",
    d: "M263.148,88.972c0,.1-4.628.172-10.335.172-98.7,0-10.335-.073-10.335-.172s4.628-.172,10.335-.172S263.148,88.879,263.148,88.972Z",
    transform: "translate(-83.149 -52.024)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2890",
    "data-name": "Path 2890",
    d: "M254.335,100.5c0,.093-9.257.172-20.676.172s-20.669-.079-20.669-.172-83.735-.179,20.669-.179C245.078,100.32,254.335,100.4,254.335,100.5Z",
    transform: "translate(-74.719 -55.927)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2891",
    "data-name": "Path 2891",
    d: "M254.335,111.792c0,.093-9.257.172-20.676.172-104.4,0-20.669-.079-20.669-.172s9.257-.172,20.669-.172S254.335,111.693,254.335,111.792Z",
    transform: "translate(-74.719 -59.755)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2892",
    "data-name": "Path 2892",
    d: "M294.782,141.909c0,.093-31.2.172-69.678.172s-69.684-.079-69.684-.172,31.189-.179,69.684-.179S294.782,141.8,294.782,141.909Z",
    transform: "translate(-65.979 -69.956)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2893",
    "data-name": "Path 2893",
    d: "M294.782,312.372c0,.093-31.2.172-69.678.172s-69.684-.079-69.684-.172,31.189-.172,69.684-.172S294.782,312.273,294.782,312.372Z",
    transform: "translate(-65.979 -127.711)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_401",
    "data-name": "Rectangle 401",
    width: 42.998,
    height: 8.067,
    transform: "translate(100.919 83.345)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_402",
    "data-name": "Rectangle 402",
    width: 18.613,
    height: 8.067,
    transform: "translate(100.919 196.166)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_403",
    "data-name": "Rectangle 403",
    width: 18.613,
    height: 8.067,
    transform: "translate(163.416 196.166)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2894",
    "data-name": "Path 2894",
    d: "M234.805,338.222c0,.1-5.812.172-12.979.172s-12.986-.073-12.986-.172,5.812-.172,12.986-.172S234.805,338.129,234.805,338.222Z",
    transform: "translate(-84.078 -136.469)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2895",
    "data-name": "Path 2895",
    d: "M335.885,338.222c0,.1-5.812.172-12.979.172s-12.986-.073-12.986-.172,5.812-.172,12.986-.172S335.885,338.129,335.885,338.222Z",
    transform: "translate(-118.323 -136.469)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2896",
    "data-name": "Path 2896",
    d: "M288.587,189.712c0,.093-25.476.172-56.863.172s-56.863-.079-56.863-.172,25.463-.172,56.863-.172S288.587,189.613,288.587,189.712Z",
    transform: "translate(-72.565 -86.154)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2897",
    "data-name": "Path 2897",
    d: "M290.772,203.632c0,.1-25.965.172-57.988.172s-57.994-.073-57.994-.172,25.959-.172,57.994-.172S290.772,203.539,290.772,203.632Z",
    transform: "translate(-72.541 -90.87)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2898",
    "data-name": "Path 2898",
    d: "M230.331,217.562c0,.093-12.887.172-28.776.172s-28.776-.079-28.776-.172,12.88-.172,28.776-.172S230.331,217.463,230.331,217.562Z",
    transform: "translate(-71.861 -95.59)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2899",
    "data-name": "Path 2899",
    d: "M322.511,262.6s-.126.053-.384.132l-1.124.344a37.838,37.838,0,0,1-4.423,1.031,20.693,20.693,0,0,1-3.266.311,13.68,13.68,0,0,1-3.881-.483,9.918,9.918,0,0,1-3.921-2.175,7.518,7.518,0,0,1-2.361-4.41,5.19,5.19,0,0,1,.324-2.711,5.084,5.084,0,0,1,1.838-2.2,3.835,3.835,0,0,1,2.9-.615,3.908,3.908,0,0,1,1.4.661,4.271,4.271,0,0,1,1.005,1.223,6.651,6.651,0,0,1,.707,3.121,8.913,8.913,0,0,1-.6,3.24,12.86,12.86,0,0,1-4.119,5.409A13.786,13.786,0,0,1,300,268.256a12.128,12.128,0,0,1-3.723-.046,12.5,12.5,0,0,1-1.845-.443,14.838,14.838,0,0,1-1.759-.78,10.744,10.744,0,0,1-2.982-2.46A8.226,8.226,0,0,1,287.93,261a5.746,5.746,0,0,1,.469-3.967,6.01,6.01,0,0,1,2.916-2.79,4.159,4.159,0,0,1,2.043-.357,3.967,3.967,0,0,1,1.924.727,5.812,5.812,0,0,1,2.089,3.4,10.943,10.943,0,0,1,.218,3.928,15.775,15.775,0,0,1-.853,3.762,14.288,14.288,0,0,1-4.152,6.2,11.327,11.327,0,0,1-6.612,2.7,9.528,9.528,0,0,1-10.169-7.015,9.052,9.052,0,0,1,.225-5.951,5.124,5.124,0,0,1,1.732-2.275,3.135,3.135,0,0,1,1.322-.555,2.162,2.162,0,0,1,1.362.264,2.929,2.929,0,0,1,1.322,2.235,7.133,7.133,0,0,1-.1,2.466,18.078,18.078,0,0,1-1.322,4.285,17.508,17.508,0,0,1-1.984,3.352,16.8,16.8,0,0,1-2.208,2.433,16.033,16.033,0,0,1-3.716,2.592,10.5,10.5,0,0,1-1.071.5l-.377.145.364-.179c.238-.119.608-.264,1.058-.522a16.828,16.828,0,0,0,3.656-2.645,18.389,18.389,0,0,0,4.126-5.766,17.659,17.659,0,0,0,1.322-4.238,7.273,7.273,0,0,0,.086-2.4,2.731,2.731,0,0,0-1.2-2.056,1.871,1.871,0,0,0-1.21-.225,2.784,2.784,0,0,0-1.184.516,4.84,4.84,0,0,0-1.64,2.162,8.761,8.761,0,0,0-.192,5.779,9.257,9.257,0,0,0,9.865,6.784,11.036,11.036,0,0,0,6.407-2.645,13.918,13.918,0,0,0,4.047-6.057,15.738,15.738,0,0,0,.833-3.69,10.718,10.718,0,0,0-.212-3.809,5.455,5.455,0,0,0-1.984-3.194,3.6,3.6,0,0,0-3.63-.337,5.686,5.686,0,0,0-2.751,2.645,5.382,5.382,0,0,0-.436,3.723,9.1,9.1,0,0,0,4.576,5.766,14.935,14.935,0,0,0,1.7.754,12.127,12.127,0,0,0,5.415.483,13.667,13.667,0,0,0,3.432-.946,13.886,13.886,0,0,0,3.008-1.759,12.562,12.562,0,0,0,4.027-5.29,8.688,8.688,0,0,0,.589-3.127,6.407,6.407,0,0,0-.661-2.982,4.219,4.219,0,0,0-.926-1.144,3.618,3.618,0,0,0-1.289-.661,3.564,3.564,0,0,0-2.7.569,4.761,4.761,0,0,0-1.746,2.07,4.972,4.972,0,0,0-.324,2.585,7.326,7.326,0,0,0,2.275,4.278,9.753,9.753,0,0,0,3.828,2.149,13.482,13.482,0,0,0,3.822.5,20.713,20.713,0,0,0,3.246-.278,43.075,43.075,0,0,0,4.423-.965l1.137-.311Z",
    transform: "translate(-105.134 -107.233)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_404",
    "data-name": "Rectangle 404",
    width: 49.908,
    height: 19.082,
    transform: "translate(134.165 0.701)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2900",
    "data-name": "Path 2900",
    d: "M272.9,53.184V48.059c0-3.306-.04-8.047-.066-13.951l.119.119-49.9.053h0l.172-.172V53.184l-.165-.165,35.7.079,10.4.046h3.775a1.362,1.362,0,0,1-.231,0h-3.465l-10.368.046-35.844.073h-.165V34.022l.172-.172h0l49.9.053h.119v.119c0,5.951-.046,10.711-.066,14.024V52.78A.932.932,0,0,1,272.9,53.184Z",
    transform: "translate(-88.831 -33.407)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2901",
    "data-name": "Path 2901",
    d: "M8.45,0h4.741a8.457,8.457,0,0,1,8.457,8.457V81H0V8.457A8.457,8.457,0,0,1,8.45,0Z",
    transform: "translate(211.182 293.316) rotate(180)",
    fill: "#f8f2ff",
    opacity: 0.48
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_405",
    "data-name": "Rectangle 405",
    width: 29.933,
    height: 11.69,
    rx: 2.45,
    transform: "translate(215.321 219.295) rotate(180)",
    fill: "#8080a4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_406",
    "data-name": "Rectangle 406",
    width: 3.438,
    height: 11.65,
    transform: "translate(212.312 219.248) rotate(180)",
    fill: "#403f51"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_407",
    "data-name": "Rectangle 407",
    width: 3.438,
    height: 11.65,
    transform: "translate(205.489 219.248) rotate(180)",
    fill: "#403f51"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_408",
    "data-name": "Rectangle 408",
    width: 3.438,
    height: 11.65,
    transform: "translate(198.672 219.248) rotate(180)",
    fill: "#403f51"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_409",
    "data-name": "Rectangle 409",
    width: 3.438,
    height: 11.65,
    transform: "translate(191.848 219.248) rotate(180)",
    fill: "#403f51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2902",
    "data-name": "Path 2902",
    d: "M2.446,0H14.613a2.433,2.433,0,0,1,2.433,2.433V3.756H0V2.433A2.433,2.433,0,0,1,2.446,0Z",
    transform: "translate(208.868 222.971) rotate(180)",
    fill: "#403f51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2903",
    "data-name": "Path 2903",
    d: "M318.786,453.328h0c4.728,0,8.563-2.288,8.563-5.1V411.289s-1.719.826-7.8-.417a17.964,17.964,0,0,0-9.316.417v36.935C310.23,451.04,314.045,453.328,318.786,453.328Z",
    transform: "translate(-118.428 -160.997)",
    fill: "#e17582"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_410",
    "data-name": "Rectangle 410",
    width: 3.385,
    height: 67.079,
    rx: 1.693,
    transform: "translate(207.181 288.192) rotate(180)",
    fill: "#fff",
    opacity: 0.46
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2904",
    "data-name": "Path 2904",
    d: "M8.457,0H13.2a8.457,8.457,0,0,1,8.457,8.457V81.024H0V8.457A8.457,8.457,0,0,1,8.457,0Z",
    transform: "translate(243.991 292.774) rotate(180)",
    fill: "#f8f2ff",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_411",
    "data-name": "Rectangle 411",
    width: 29.933,
    height: 11.69,
    rx: 2.45,
    transform: "translate(248.123 218.746) rotate(180)",
    fill: "#8080a4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_412",
    "data-name": "Rectangle 412",
    width: 3.438,
    height: 11.65,
    transform: "translate(245.108 218.706) rotate(180)",
    fill: "#403f51"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_413",
    "data-name": "Rectangle 413",
    width: 3.438,
    height: 11.65,
    transform: "translate(238.291 218.706) rotate(180)",
    fill: "#403f51"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_414",
    "data-name": "Rectangle 414",
    width: 3.438,
    height: 11.65,
    transform: "translate(231.467 218.706) rotate(180)",
    fill: "#403f51"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_415",
    "data-name": "Rectangle 415",
    width: 3.438,
    height: 11.65,
    transform: "translate(224.644 218.706) rotate(180)",
    fill: "#403f51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2905",
    "data-name": "Path 2905",
    d: "M2.433,0H14.613a2.433,2.433,0,0,1,2.433,2.433V3.756H0V2.433A2.433,2.433,0,0,1,2.433,0Z",
    transform: "translate(241.676 222.402) rotate(180)",
    fill: "#403f51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2906",
    "data-name": "Path 2906",
    d: "M368.4,452.5h0c4.728,0,8.556-2.281,8.556-5.1V410.469s-1.719.827-7.8-.417a17.932,17.932,0,0,0-9.31.417V447.4C359.84,450.207,363.668,452.5,368.4,452.5Z",
    transform: "translate(-135.236 -160.719)",
    fill: "#e17582"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_416",
    "data-name": "Rectangle 416",
    width: 3.385,
    height: 67.079,
    rx: 1.693,
    transform: "translate(239.984 287.65) rotate(180)",
    fill: "#fff",
    opacity: 0.46
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2907",
    "data-name": "Path 2907",
    d: "M203.51,363.34s10.579,62.2,10.8,75.377l58.741-4.437s-5.792-46.681-8.834-66.987Z",
    transform: "translate(-82.272 -145.037)",
    fill: "#4d5a64",
    opacity: 0.63
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_474",
    "data-name": "Group 474",
    transform: "translate(135.809 219.401)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2908",
    "data-name": "Path 2908",
    d: "M269.307,435.564s2.294-26.534-.76-43.944c-1.706-9.852-5.951-24.246-5.951-24.246L227.79,365s-3.154,20.438-1.984,39.269a185.045,185.045,0,0,0,5.521,34.442l17.072-1.4L247,419.734a4.43,4.43,0,0,0,4.086-.529l1.322,17.76Z",
    transform: "translate(-225.546 -365)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2909",
    "data-name": "Path 2909",
    d: "M244.5,423.286c.476.853,1.23,3.114,3.306,2.136s2.506-5.547,2.506-5.547l1.984-.2a17.81,17.81,0,0,0,.76,1.865c.542,1.177,1.891,3.114,3.564,3.015s1.9-1.541,2.46-5.475-.093-7.042,0-9.766,2.347-4.113,3.061-5.29.767-1.951,1.2-4.576,1.005-2.949.463-7.353-3.723-5.29-3.723-5.29a8.626,8.626,0,0,0-3.67.1c-1.369.522-1.587,2.288-1.389,4.271s1.878,8.483,2.109,11.307-2.1,7.7-3.63,8.893-1.891,3.809-1.891,3.809l-1.5.145c-.2-1.4-5.362-6.91-6.572-8.926s-.853-5.29-.84-6.123.529-5.739.436-8.6a3.213,3.213,0,0,0-2.473-3.253l-2.929.284c-2.407.238-3.187,4.39-3.187,4.39a34.315,34.315,0,0,0,.35,4.814,41.878,41.878,0,0,0,2.691,7.234c.78,1.666,3.1,3.385,3.967,5.038s.919,5.085.992,6.05a43.206,43.206,0,0,0,1.957,7.042Zm9.581-5.415c-.615-3.207,1.124-4.159,1.488-4.371.5-.278,1.217-.549,1.508-.053l-.053-.04a.849.849,0,0,1,.126.139,3.385,3.385,0,0,1,.364,2.532c-.3,1.984-.5,4.271-1,4.628s-1.812.317-2.446-2.863Zm-9.581-.522a3.5,3.5,0,0,1-.046-2.559.661.661,0,0,1,.1-.159l-.046.046c.2-.542.959-.423,1.494-.238.4.139,2.248.754,2.156,4.007s-1.4,3.564-1.944,3.306-1.111-2.493-1.726-4.4Z",
    transform: "translate(-92.785 -152.933)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2910",
    "data-name": "Path 2910",
    d: "M254.982,417.137c-.516,0-.979-1.984-.979-1.984a18.357,18.357,0,0,1-.926-2.235,9.666,9.666,0,0,0-1.785-2.645,11,11,0,0,1-1.382-4.351c-.1-1.184-.39-1.276-.39-1.276-1.461-.35-1.415-3.2-1.627-5.871s.734-2.513.734-2.513.562-.06,1.772,2.043,2.07,2.823,3.306,2.751l.661-.066c1.243-.046,1.984-1.045,2.823-3.346s1.408-2.361,1.408-2.361.9-.311,1.117,2.341.714,5.442-.661,6.09c0,0-.284.145-.185,1.322a11.092,11.092,0,0,1-.661,4.562,9.224,9.224,0,0,0-1.322,2.916,21.663,21.663,0,0,1-.549,2.387s-.37,2.083-.873,2.2Z",
    transform: "translate(-97.298 -155.856)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2911",
    "data-name": "Path 2911",
    d: "M255.288,368.2s.661.145.661,1.243.291,1.726.172,2.03a5.144,5.144,0,0,1-.536.853s.813.212.76,1.389.278,2.308.251,2.823-.476.708-.589,1.005.747-.073.912.932-.159,1.779.212,2.685.443,2.136-.2,2.645-.231,1.124-.06,1.613a7.934,7.934,0,0,1,.436,1.984c.2,1.322-.893,3.372-2.07,3.339s-2.883-1.4-2.962-2.261a9.594,9.594,0,0,1,.555-3.306c.284-.542.661-.582.37-1.131s-.569.35-.846-.43a4.1,4.1,0,0,1-.37-2.321,16.269,16.269,0,0,0,.086-2.42c.066-.952.866-1.177.714-1.382s-.6-.086-.582-1.038.291-.324.126-1.779-.317-2.308.145-2.208.139-.522-.119-1.521-.456-.608-.317-1.719S255.288,368.2,255.288,368.2Z",
    transform: "translate(-98.682 -146.683)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2912",
    "data-name": "Path 2912",
    d: "M276.808,420.223l-1.124-1.322-.238-2.823s-1.9-.866-2.691,2.413-.046,4.774-.046,4.774l2.44-.231a5.481,5.481,0,0,1,1.256,2.843c.079,1.455-.721,1.322-.37,3.861a20.887,20.887,0,0,0,.708,3.557l.271,19.929,3.392-.331-.146-21.159s.661-.661.939-3.914.06-7.379-1.389-8.417S276.808,420.223,276.808,420.223Z",
    transform: "translate(-105.609 -162.869)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2913",
    "data-name": "Path 2913",
    d: "M236.011,424.044l.893-1.547-.212-2.83s1.732-1.223,3.028,1.858.793,4.688.793,4.688l-2.44.238a5.839,5.839,0,0,0-.78,3.028c.145,1.441.919,1.164.972,3.729a21.973,21.973,0,0,1-.119,3.63l2.9,19.677-3.4.331-3.227-20.835s-.787-.549-1.541-3.67-1.23-7.273.04-8.543C233.565,423.026,234.947,423.112,236.011,424.044Z",
    transform: "translate(-91.968 -164.039)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2914",
    "data-name": "Path 2914",
    d: "M203.5,363.32l1.1.06,3.207.2,12.259.774,44.1,2.823h.093v.086c1.428,9.64,2.837,20.2,4.318,31.447s3,23.188,4.542,35.56v.066h-.066l-4.5.357-54.219,4.066H214.2v-.126c-.106-2.711-.357-5.415-.661-8.067l-.45-3.967q-.245-1.984-.5-3.868c-.317-2.546-.661-5.038-1.012-7.472l-1.018-7.081c-1.322-9.171-2.645-17.191-3.676-23.869L203.47,363.28a1.457,1.457,0,0,0,.066.357c.066.231.106.6.192,1.065.159.939.4,2.321.7,4.119.608,3.6,1.481,8.86,2.559,15.512s2.36,14.712,3.723,23.889q.5,3.432,1.031,7.081c.324,2.42.7,4.919,1.018,7.472l.5,3.868q.218,1.984.456,3.967c.291,2.645.542,5.362.661,8.093l-.126-.119,54.219-4.1,4.5-.357-.053.073c-1.541-12.365-3.068-24.293-4.529-35.54s-2.87-21.82-4.3-31.44l.106.093-44.069-2.9-12.285-.82-3.213-.218Z",
    transform: "translate(-82.258 -145.017)",
    fill: "#2e353a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2915",
    "data-name": "Path 2915",
    d: "M106.7,433.748l-4.384,15.571s13.971,9.8,13.436,12.755L86,454.424l5.865-24.544Z",
    transform: "translate(-42.46 -167.581)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2916",
    "data-name": "Path 2916",
    d: "M96.634,453.705a1.27,1.27,0,0,0-1.184,1.21,1.223,1.223,0,0,0,1.157,1.217,1.322,1.322,0,0,0,1.25-1.283c-.06-.628-.741-1.283-1.322-1.131",
    transform: "translate(-45.661 -175.649)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_475",
    "data-name": "Group 475",
    transform: "translate(43.54 284.397)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2917",
    "data-name": "Path 2917",
    d: "M86,465.746l.661-2.446,28.286,8.232s1.184.926.8,1.845Z",
    transform: "translate(-86 -463.3)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2918",
    "data-name": "Path 2918",
    d: "M109.868,459.067c-.046.152-.787,0-1.62.324s-1.369.826-1.488.734.311-.9,1.322-1.236S109.927,458.915,109.868,459.067Z",
    transform: "translate(-49.487 -177.362)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2919",
    "data-name": "Path 2919",
    d: "M114.434,462.377c0,.159-.661.245-1.322.754s-.952,1.131-1.1,1.084,0-.906.787-1.514S114.467,462.238,114.434,462.377Z",
    transform: "translate(-51.256 -178.549)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2920",
    "data-name": "Path 2920",
    d: "M116.958,467.744c-.139,0-.159-.793.41-1.514s1.322-.873,1.362-.734-.5.469-.959,1.065S117.084,467.8,116.958,467.744Z",
    transform: "translate(-52.92 -179.631)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2921",
    "data-name": "Path 2921",
    d: "M110.793,453.191c-.1.119-.714-.258-1.547-.41s-1.541-.053-1.587-.2.7-.516,1.679-.324S110.892,453.092,110.793,453.191Z",
    transform: "translate(-49.797 -175.142)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2922",
    "data-name": "Path 2922",
    d: "M93.66,441.2,93,457.382s15.869,6.156,15.988,9.164L78.3,466.3l.066-25.271Z",
    transform: "translate(-39.851 -171.358)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2923",
    "data-name": "Path 2923",
    d: "M85.689,463.58a1.283,1.283,0,0,0-.879,1.455,1.2,1.2,0,0,0,1.4.906,1.355,1.355,0,0,0,.926-1.547,1.236,1.236,0,0,0-1.547-.774",
    transform: "translate(-42.049 -178.991)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_476",
    "data-name": "Group 476",
    transform: "translate(38.416 292.397)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2924",
    "data-name": "Path 2924",
    d: "M78.25,477.946l.106-2.546,29.384,1.184s1.362.622,1.2,1.607Z",
    transform: "translate(-78.25 -475.4)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2925",
    "data-name": "Path 2925",
    d: "M99.8,465.456c0,.152-.754.218-1.5.7s-1.137,1.131-1.276,1.071.093-.946,1.005-1.521S99.831,465.31,99.8,465.456Z",
    transform: "translate(-46.181 -179.584)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2926",
    "data-name": "Path 2926",
    d: "M105.039,467.6c0,.145-.615.4-1.131,1.051s-.661,1.322-.813,1.322-.238-.879.417-1.666S105.039,467.453,105.039,467.6Z",
    transform: "translate(-48.215 -180.339)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2927",
    "data-name": "Path 2927",
    d: "M108.72,472.267c-.139.033-.337-.741.053-1.574s1.091-1.17,1.157-1.038-.377.575-.661,1.263S108.846,472.254,108.72,472.267Z",
    transform: "translate(-50.098 -181.047)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2928",
    "data-name": "Path 2928",
    d: "M99.237,459.642c-.06.139-.747-.079-1.594,0s-1.514.324-1.587.192.562-.661,1.56-.727S99.323,459.523,99.237,459.642Z",
    transform: "translate(-45.865 -177.48)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2929",
    "data-name": "Path 2929",
    d: "M72.626,262.11v12.8l3.352,49.868s-2.089,24.193-3.372,37.854c-1.111,11.855.707,32.511.707,32.511H92.845l7.009-68.878,4.337-42.978,7.564-19.532Z",
    transform: "translate(-37.8 -110.741)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2930",
    "data-name": "Path 2930",
    d: "M132.125,264.785l-3.742,69.578-19.757,52.1-.912,3.134L96.05,386.7l8.675-123.275Z",
    transform: "translate(-45.865 -111.188)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2931",
    "data-name": "Path 2931",
    d: "M114.687,294.94a1.984,1.984,0,0,1,0,.291c0,.212,0,.489,0,.846,0,.767-.053,1.865-.1,3.266-.079,2.83-.278,6.923-.555,11.981-.588,10.116-1.686,24.074-3.405,39.441s-3.551,29.238-4.913,39.276c-.661,5-1.25,9.052-1.64,11.9-.2,1.389-.357,2.473-.463,3.227-.06.357-.1.661-.132.84a1.58,1.58,0,0,1-.059.284V406c0-.2.06-.483.1-.84.093-.76.225-1.845.4-3.24.357-2.823.879-6.883,1.527-11.9,1.322-10.044,3.114-23.916,4.807-39.282s2.85-29.3,3.5-39.408c.311-5.052.549-9.144.661-11.974.073-1.4.126-2.493.165-3.26,0-.357.04-.661.053-.846a1.447,1.447,0,0,1,.053-.311Z",
    transform: "translate(-48.362 -121.863)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2932",
    "data-name": "Path 2932",
    d: "M121.3,268.091a1.012,1.012,0,1,1-.287-.726,1.005,1.005,0,0,1,.287.726Z",
    transform: "translate(-53.738 -112.418)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2933",
    "data-name": "Path 2933",
    d: "M145.655,277.313a6.611,6.611,0,0,1-1.375-1.322,15.942,15.942,0,0,1-2.46-3.967,16.233,16.233,0,0,1-1.23-4.5,6.553,6.553,0,0,1-.046-1.931c.06,0,.1.734.3,1.9a19.465,19.465,0,0,0,1.322,4.384,19.174,19.174,0,0,0,2.321,3.921C145.186,276.745,145.7,277.267,145.655,277.313Z",
    transform: "translate(-60.922 -111.92)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2934",
    "data-name": "Path 2934",
    d: "M144.77,167.18s3.736,1.468,5.468,6.943c1.2,3.809,6.837,32.161,6.837,32.161l-7.855,5.177-3.194-26.547Z",
    transform: "translate(-62.371 -78.579)",
    fill: "#f7f7f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2935",
    "data-name": "Path 2935",
    d: "M89.86,146.7l-2.46,4.364s-16.444,8.358-16.385,9.178c0,0,.919,31.2,1.091,54.08.066,8.642-.251,16.576-.423,20.4-.456,10.017-.813,48.929-.813,48.929l59.508-1.408-10.645-122-8.4-3.67-1.071-2.189-3.855-3.134Z",
    transform: "translate(-37.334 -71.64)",
    fill: "#f7f7f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2936",
    "data-name": "Path 2936",
    d: "M135.934,299.616a1.323,1.323,0,0,0,0-.264,7.181,7.181,0,0,0-.033-.774c-.04-.707-.093-1.712-.165-3-.152-2.612-.377-6.367-.661-10.989-.562-9.3-1.322-22.111-2.189-36.267s-1.554-26.971-2.089-36.274c-.245-4.628-.45-8.377-.588-11-.073-1.283-.126-2.281-.165-2.989,0-.324-.04-.582-.053-.774a1.984,1.984,0,0,0-.033-.264,1.571,1.571,0,0,0,0,.264v.78c0,.7.053,1.706.1,2.989.093,2.6.258,6.361.476,11,.436,9.257,1.137,22.117,1.984,36.287s1.666,26.977,2.294,36.254c.317,4.628.582,8.371.76,10.989.1,1.276.179,2.281.231,2.982l.066.78A1.19,1.19,0,0,0,135.934,299.616Z",
    transform: "translate(-57.35 -88.692)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2937",
    "data-name": "Path 2937",
    d: "M116.279,152.54l1.382,9.554,2.473,19.175-10.778-18.5L100,150.51l15.419,10.8.192-8.953",
    transform: "translate(-47.203 -72.931)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2938",
    "data-name": "Path 2938",
    d: "M95.76,154.18a4.213,4.213,0,0,0,.3.747c.231.522.536,1.217.919,2.07l3.346,7.273.04.093h2.354l-.106-.3-1.653,1.355-.152.126.139.139,3.134,3.068,10.083,9.779,3.081,2.929.853.787a1.726,1.726,0,0,0,.311.258,1.422,1.422,0,0,0-.264-.311l-.8-.833-3.008-3.015-10-9.852c-1.078-1.058-2.136-2.083-3.141-3.061v.258l1.646-1.362.364-.3h-2.724l.145.093c-1.408-2.936-2.6-5.422-3.465-7.22-.417-.84-.747-1.521-1-2.03a5.032,5.032,0,0,0-.4-.681Z",
    transform: "translate(-45.766 -74.174)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2939",
    "data-name": "Path 2939",
    d: "M129.854,183.875a7.98,7.98,0,0,0,.218-1.19c.119-.827.271-1.924.456-3.253.37-2.751.86-6.553,1.375-10.751l.476-3.914v-.152l-.152-.04-2.7-.661v.317l2.711-.483.185-.033-.079-.165-1.785-3.881c-.2-.417-.37-.767-.509-1.051a1.323,1.323,0,0,0-.2-.357,1.654,1.654,0,0,0,.132.39c.119.291.264.661.436,1.084.423.992.992,2.321,1.673,3.928l.106-.192-2.718.443-.78.126.767.192,2.7.661-.132-.185c-.159,1.243-.317,2.559-.489,3.908-.516,4.205-.965,8.007-1.27,10.764-.139,1.322-.258,2.44-.344,3.306a7.677,7.677,0,0,0-.066,1.19Z",
    transform: "translate(-56.923 -75.557)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2940",
    "data-name": "Path 2940",
    d: "M105.37,274.2h-.383l-1.144.073-4.39.317L83.729,275.8H83.57v.159c.251,2.956.529,6.169.82,9.554q.218,2.552.45,5.217c.079.893.152,1.785.231,2.691a7.273,7.273,0,0,0,.218,1.389,4.873,4.873,0,0,0,.622,1.322,5.667,5.667,0,0,0,3.7,2.228,30.123,30.123,0,0,0,4.192.225,35.5,35.5,0,0,0,7.862-.86,11.841,11.841,0,0,0,1.792-.588,5.489,5.489,0,0,0,.833-.423,2.71,2.71,0,0,0,.377-.3,3.839,3.839,0,0,0,.3-.37,8.774,8.774,0,0,0,1.025-3.352,41.225,41.225,0,0,0,.311-6.222c-.059-3.809-.331-6.877-.536-8.992-.1-1.058-.2-1.878-.271-2.427a5.077,5.077,0,0,0-.086-.661.661.661,0,0,0-.046-.212s0,.073,0,.218a3.473,3.473,0,0,0,.053.661c.053.582.119,1.4.2,2.433.165,2.116.4,5.184.423,8.979a43.462,43.462,0,0,1-.35,6.176,8.6,8.6,0,0,1-1,3.22,2.691,2.691,0,0,1-1.375.979,11.37,11.37,0,0,1-1.739.562,35.5,35.5,0,0,1-7.782.833,29.815,29.815,0,0,1-4.126-.225,5.329,5.329,0,0,1-3.471-2.083,4.8,4.8,0,0,1-.569-1.19,7.182,7.182,0,0,1-.2-1.322c-.079-.906-.159-1.805-.231-2.7-.159-1.772-.311-3.518-.463-5.21-.3-3.392-.588-6.612-.853-9.554l-.139.172,15.611-1.362,4.417-.4,1.177-.112A3.088,3.088,0,0,0,105.37,274.2Z",
    transform: "translate(-41.636 -114.827)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_477",
    "data-name": "Group 477",
    transform: "translate(43.686 179.556)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2941",
    "data-name": "Path 2941",
    d: "M86.22,304.74c1.679,4.377,6.063,4.628,10.784,3.967,4.437-.661,8.708-1.58,9.039-2.85a6.047,6.047,0,0,1-3.967,5.032,15.419,15.419,0,0,1-6.83.959c-2.427-.112-4.523,0-6.526-1.382A6.618,6.618,0,0,1,86.22,304.74Z",
    transform: "translate(-86.22 -304.74)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2942",
    "data-name": "Path 2942",
    d: "M151.528,243.715a.779.779,0,0,1,0-.165l-.06-.476q-.066-.661-.2-1.845c-.159-1.64-.383-3.967-.661-6.8-.542-5.739-1.27-13.674-2.037-22.435s-1.428-16.7-1.871-22.481c-.218-2.876-.377-5.2-.469-6.81-.053-.807-.073-1.428-.086-1.858v-.483a.476.476,0,0,1,0-.165c.159,1.865,1.263,14.5,2.77,31.738.754,8.754,1.441,16.676,1.937,22.448.231,2.85.423,5.164.555,6.8.06.78.106,1.4.139,1.851v.483a.661.661,0,0,1-.02.192Z",
    transform: "translate(-62.835 -82.99)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2943",
    "data-name": "Path 2943",
    d: "M161.55,226.071a8.265,8.265,0,0,1,.278,2.817c-.139,1.448-.2,5.005-4.06,6.222s-5.726.053-6.91-1.58l-.588-7.075,4.126-2.724Z",
    transform: "translate(-64.234 -97.738)",
    fill: "#f7f7f7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_478",
    "data-name": "Group 478",
    transform: "translate(35.163 132.882)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2944",
    "data-name": "Path 2944",
    d: "M103.276,234.15s-9.859,9.74-17.515,11.141-10.394-1.322-12.431-8.179Z",
    transform: "translate(-73.33 -234.15)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2945",
    "data-name": "Path 2945",
    d: "M68.9,166.82s-6.262,5.805-4.476,19.552c1.653,12.774,4.628,30.561,8.516,32.63s12.384,1.031,18.58-2.48,24.147-13.006,24.147-13.006l-7.432-13.224L84.3,199.55s-3.094-21.159-4.952-24.835",
    transform: "translate(-35.042 -78.457)",
    fill: "#f7f7f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2946",
    "data-name": "Path 2946",
    d: "M79.172,174.592s.066.139.185.41c.053.132.132.3.212.5s.145.456.238.727c.35,1.1.767,2.744,1.223,4.886.926,4.278,2.043,10.52,3.22,18.3l-.172-.106,23.929-9.323.132-.053.073.126c2.347,4.179,4.847,8.6,7.439,13.224l.086.159-.159.086L100.224,211.8l-7.531,4.053c-1.236.661-2.466,1.355-3.742,1.9a31.193,31.193,0,0,1-3.914,1.355,25.6,25.6,0,0,1-7.987.926,11.7,11.7,0,0,1-3.828-.827l-.45-.2c-.145-.073-.284-.179-.43-.271a4.35,4.35,0,0,1-.661-.7,9.158,9.158,0,0,1-1.012-1.633,36.717,36.717,0,0,1-2.407-6.929c-.6-2.294-1.078-4.549-1.508-6.738-.846-4.371-1.474-8.47-1.984-12.219a59.409,59.409,0,0,1-.853-10.183,25.37,25.37,0,0,1,1.362-7.584,16.821,16.821,0,0,1,2.268-4.311,10.045,10.045,0,0,1,.82-.972,3.871,3.871,0,0,1,.317-.291l-.291.317a11.434,11.434,0,0,0-.787.985,17.278,17.278,0,0,0-2.2,4.318,25.35,25.35,0,0,0-1.322,7.544,58.1,58.1,0,0,0,.9,10.136c.542,3.742,1.184,7.842,2.043,12.206.43,2.175.912,4.423,1.521,6.711a36.624,36.624,0,0,0,2.387,6.863,9.3,9.3,0,0,0,.959,1.567,4.245,4.245,0,0,0,.661.661,3.1,3.1,0,0,0,.383.231l.423.192a11.372,11.372,0,0,0,3.729.774,25.344,25.344,0,0,0,7.875-.919,31.794,31.794,0,0,0,3.861-1.322c1.27-.549,2.473-1.23,3.716-1.891l7.531-4.06,15.36-8.265-.073.238-7.419-13.224.2.073L84.2,199.572l-.152.06v-.159c-1.144-7.769-2.222-14.018-3.1-18.3-.43-2.142-.826-3.8-1.157-4.893-.079-.271-.152-.516-.218-.727l-.192-.509C79.244,174.738,79.172,174.592,79.172,174.592Z",
    transform: "translate(-34.97 -78.579)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_417",
    "data-name": "Rectangle 417",
    width: 11.882,
    height: 3.954,
    transform: "translate(64.679 111.856) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2947",
    "data-name": "Path 2947",
    d: "M103.72,198.9a19.314,19.314,0,0,1,3.7-.179,19.361,19.361,0,0,1,3.709.179,20.4,20.4,0,0,1-3.709.172,20.359,20.359,0,0,1-3.7-.172Z",
    transform: "translate(-48.463 -89.256)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_479",
    "data-name": "Group 479",
    transform: "translate(51.21 82.822)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2948",
    "data-name": "Path 2948",
    d: "M118.719,183.7,101.23,169.509l.417-1.236h-1.521L97.6,158.44l3.637,7.141,2.1-.1-1.527,1.4Z",
    transform: "translate(-97.6 -158.44)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2949",
    "data-name": "Path 2949",
    d: "M95.08,165.555l.661-.264c0-.033-1.435-3.451-2.843-7.075a7,7,0,0,1-.6-3.557,1.66,1.66,0,0,1,1.679-1.322l.463-.245.238-.423a2.823,2.823,0,0,0-3.061,1.891,7.677,7.677,0,0,0,.661,3.928C93.639,162.13,95.06,165.522,95.08,165.555Z",
    transform: "translate(-44.353 -73.648)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2950",
    "data-name": "Path 2950",
    d: "M94.575,179.786l.879-.344c-.721-1.858-1.706-5.144-1.283-6.07a2.757,2.757,0,0,1,1.891-1.25,3.161,3.161,0,0,1,2.757.569c1.005.853,2.526,3.855,3.028,4.946l.853-.4c-.073-.165-1.9-4.113-3.273-5.29a4.086,4.086,0,0,0-3.571-.767A3.59,3.59,0,0,0,93.318,173C92.6,174.536,94.237,178.953,94.575,179.786Z",
    transform: "translate(-44.879 -79.892)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2951",
    "data-name": "Path 2951",
    d: "M104.859,198.337a4.363,4.363,0,0,0,3.18-1.732l-.357-.317c-1.124,1.276-2.288,1.779-3.438,1.508-4.7-1.1-8.285-14.163-8.318-14.3l-.456.119c.152.549,3.69,13.469,8.662,14.632a3.036,3.036,0,0,0,.727.086Z",
    transform: "translate(-45.668 -84.108)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2952",
    "data-name": "Path 2952",
    d: "M113.023,203.13h0a.562.562,0,0,0,.734.053l1.018-.76a.661.661,0,0,0,.192-.939h0a.661.661,0,0,0-1.038-.1l-.919.952A.562.562,0,0,0,113.023,203.13Z",
    transform: "translate(-51.557 -90.097)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2953",
    "data-name": "Path 2953",
    d: "M106.162,197.768a3.683,3.683,0,0,0,3.207-1.435c2.889-4.053-2.559-15.307-2.79-15.783l-.423.2c.053.119,5.561,11.478,2.83,15.307-.714,1-1.984,1.4-3.716,1.177l-.06.463a6.925,6.925,0,0,0,.952.066Z",
    transform: "translate(-48.968 -83.108)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2954",
    "data-name": "Path 2954",
    d: "M105.471,205.833h0a.562.562,0,0,1-.516.522l-1.27.106a.661.661,0,0,1-.76-.575h0a.661.661,0,0,1,.707-.767l1.322.112a.569.569,0,0,1,.516.6Z",
    transform: "translate(-48.191 -91.431)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_143",
    "data-name": "Ellipse 143",
    cx: 3.359,
    cy: 3.359,
    r: 3.359,
    transform: "translate(76.548 93.878)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_144",
    "data-name": "Ellipse 144",
    cx: 3.359,
    cy: 3.359,
    r: 3.359,
    transform: "translate(76.548 93.878)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2955",
    "data-name": "Path 2955",
    d: "M137.25,178.97a2.486,2.486,0,1,0,2.48-2.48A2.486,2.486,0,0,0,137.25,178.97Z",
    transform: "translate(-59.823 -81.733)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2956",
    "data-name": "Path 2956",
    d: "M128.516,156.379c.317.456,3.828,7.868,5.746,11.6l.562-.291c-.284-.549-5.389-11.082-5.786-11.67L125.322,153l-.132.707Z",
    transform: "translate(-55.737 -73.775)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2957",
    "data-name": "Path 2957",
    d: "M127.929,179.172c2.433,2.427,8.6,8.741,8.6,8.741l1.646-.992-8.675-9.257a1.084,1.084,0,0,0-1.4-.159h0a1.084,1.084,0,0,0-.172,1.666Z",
    transform: "translate(-56.559 -82.015)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2958",
    "data-name": "Path 2958",
    d: "M130.74,197.777l2.07-5.832a3.306,3.306,0,0,1,2.982-2.235h.311c1.243.139,7.571.555,7.571.555l2.446,2.744a1.25,1.25,0,0,1,0,1.653h0l.707,4.959-1.369.952.139,3.465s-1.236.82-1.785.549l-.555-.278-.82-.827-2.341,3.306-3.233,1.871Z",
    transform: "translate(-57.618 -86.212)",
    fill: "#ffbf9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2959",
    "data-name": "Path 2959",
    d: "M149.808,196.328a11.242,11.242,0,0,0-.886-.959,4.172,4.172,0,0,0-1.184-.714,8.865,8.865,0,0,0-1.713-.231,28.921,28.921,0,0,1-4.516-.608,28.883,28.883,0,0,1,4.549.251,7.518,7.518,0,0,1,1.792.278,3.967,3.967,0,0,1,1.243.833A2.1,2.1,0,0,1,149.808,196.328Z",
    transform: "translate(-61.266 -87.6)",
    fill: "#ff9a6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2960",
    "data-name": "Path 2960",
    d: "M149.964,202.39a10.249,10.249,0,0,0-.509-1.263,4.913,4.913,0,0,0-2.446-2.05,9.3,9.3,0,0,0-3.24-.549,7.2,7.2,0,0,1-1.389-.04,4.133,4.133,0,0,1,1.389-.212,8.027,8.027,0,0,1,3.372.463,4.761,4.761,0,0,1,2.539,2.268A2.142,2.142,0,0,1,149.964,202.39Z",
    transform: "translate(-61.561 -89.106)",
    fill: "#ff9a6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2961",
    "data-name": "Path 2961",
    d: "M149.508,208.6a2.684,2.684,0,0,1-.331-1.362,4.563,4.563,0,0,0-.311-1.422,1.746,1.746,0,0,0-1.322-.985,24.594,24.594,0,0,0-3.306-.476,3.763,3.763,0,0,1-1.369-.317,9.834,9.834,0,0,1,1.4.066,16.4,16.4,0,0,1,3.366.377,2.692,2.692,0,0,1,.926.43,1.865,1.865,0,0,1,.582.774,4.206,4.206,0,0,1,.258,1.534C149.429,208.079,149.568,208.581,149.508,208.6Z",
    transform: "translate(-61.727 -91.065)",
    fill: "#ff9a6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2962",
    "data-name": "Path 2962",
    d: "M144.144,194.4,116.85,222.587l1.051,1.065,19.552-2.2,26.309-25.066-.026-1.2Z",
    transform: "translate(-52.912 -87.801)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_480",
    "data-name": "Group 480",
    transform: "translate(84.38 118.116)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2963",
    "data-name": "Path 2963",
    d: "M159.73,213.446a6.235,6.235,0,0,0-4.794-1.6,8.788,8.788,0,0,0-4.721,1.984,6.361,6.361,0,0,0-2.354,3.372c-.555,2.367,1.4,5.68,3.544,6.83h0c2.724-2.189,5.376-5.547,8.1-7.729a2.347,2.347,0,0,0,.946-1.21,1.924,1.924,0,0,0-.721-1.646Z",
    transform: "translate(-147.765 -211.817)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2964",
    "data-name": "Path 2964",
    d: "M164.185,197.015a2.547,2.547,0,0,1-.357,0h-1.045l-3.914-.046-13.621-.238.126-.053-6.837,7.095-14.183,14.593-4.324,4.39-1.19,1.184a4.411,4.411,0,0,1-.43.4,3.1,3.1,0,0,1,.39-.423l1.144-1.23,4.245-4.47c3.63-3.775,8.6-8.953,14.1-14.665,2.413-2.5,4.734-4.893,6.85-7.075l.053-.053h.053l13.6.39,3.908.139L163.8,197A1.748,1.748,0,0,1,164.185,197.015Z",
    transform: "translate(-53.44 -88.485)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2965",
    "data-name": "Path 2965",
    d: "M158.324,209.82a13.152,13.152,0,0,1,3.511.483,23.47,23.47,0,0,1,3.233,2.942s0,1.719-.661,1.785a6.007,6.007,0,0,1,.139,1.17,1.935,1.935,0,0,1-1.1,2.341s.139,1.58-.344,1.984a9.4,9.4,0,0,1-1.031.754s-.073,1.739-2.407,1.719l-2.189.965s-4.866-.456-4.351-1.031a22.828,22.828,0,0,0,1.686-3.425s-3.306-2.427-3.266-3.18.344-.827.344-.827-.132-1.441,1.031-1.58c0,0,.9-1.792,1.792-1.858s6.949,2.129,6.949,2.129l-2.268-1.924s-2.275-.344-2.2-1.1S158.324,209.82,158.324,209.82Z",
    transform: "translate(-64.664 -93.025)",
    fill: "#ffbf9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2966",
    "data-name": "Path 2966",
    d: "M158.049,222a33.061,33.061,0,0,1-3.075-1.488A33.425,33.425,0,0,1,151.9,219a10.8,10.8,0,0,1,3.233,1.157A11.042,11.042,0,0,1,158.049,222Z",
    transform: "translate(-64.786 -96.135)",
    fill: "#ff9a6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2967",
    "data-name": "Path 2967",
    d: "M162.009,218.863a24.463,24.463,0,0,1-3.967-1.283,23.855,23.855,0,0,1-3.822-1.62,24.464,24.464,0,0,1,3.967,1.283,23.856,23.856,0,0,1,3.822,1.62Z",
    transform: "translate(-65.572 -95.105)",
    fill: "#ff9a6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2968",
    "data-name": "Path 2968",
    d: "M99.8,117.114a55.217,55.217,0,0,1-1.865-9.171,19,19,0,0,1,1.217-9.2c.192-.436,1.752-3.306,2.215-3.266.337.046-.661,2.777-.516,3.081a16.083,16.083,0,0,1,1.322,9.455,42.224,42.224,0,0,1-2.347,9.1",
    transform: "translate(-46.461 -54.287)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2969",
    "data-name": "Path 2969",
    d: "M100.714,103.046c.145-7.842,4.833-14.282,12.662-13.885l.721.079a14,14,0,0,1,12.563,14.275c-.165,6.791-.436,14.289-.86,17.9-.879,7.465-8.483,7.842-8.483,7.842l-1.732,11.518L99.59,129.653Z",
    transform: "translate(-47.064 -52.14)",
    fill: "#ffbf9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2970",
    "data-name": "Path 2970",
    d: "M121.525,147.848a18.2,18.2,0,0,1-9.435-3.908,9.021,9.021,0,0,0,9.025,6.506Z",
    transform: "translate(-51.299 -70.705)",
    fill: "#ff9a6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2971",
    "data-name": "Path 2971",
    d: "M135.082,119.733a1.071,1.071,0,0,1-1.144.965,1.025,1.025,0,0,1-1-1.078,1.078,1.078,0,0,1,1.144-.972,1.031,1.031,0,0,1,1,1.084Z",
    transform: "translate(-58.362 -62.136)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2972",
    "data-name": "Path 2972",
    d: "M135.41,114.582c-.145.119-.893-.562-2.043-.661s-2.05.37-2.162.218.106-.311.5-.536a2.916,2.916,0,0,1,1.752-.344,2.843,2.843,0,0,1,1.607.707C135.39,114.258,135.483,114.523,135.41,114.582Z",
    transform: "translate(-57.765 -60.304)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2973",
    "data-name": "Path 2973",
    d: "M120.212,119.05a1.078,1.078,0,0,1-1.144.972,1.031,1.031,0,0,1-1-1.084,1.078,1.078,0,0,1,1.144-.939A1.025,1.025,0,0,1,120.212,119.05Z",
    transform: "translate(-53.324 -61.915)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2974",
    "data-name": "Path 2974",
    d: "M118.31,113.482c-.145.126-.893-.555-2.043-.661s-2.05.37-2.162.212.106-.3.5-.529a2.916,2.916,0,0,1,1.752-.344,2.843,2.843,0,0,1,1.607.707C118.29,113.165,118.383,113.429,118.31,113.482Z",
    transform: "translate(-51.972 -59.931)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2975",
    "data-name": "Path 2975",
    d: "M125.31,123.254a7.313,7.313,0,0,1,1.9-.139c.291,0,.575,0,.661-.225a1.507,1.507,0,0,0-.106-.893l-.628-2.327a35.9,35.9,0,0,1-1.322-6.05,38.378,38.378,0,0,1,1.818,5.951c.2.813.4,1.593.6,2.334a1.719,1.719,0,0,1,0,1.17.734.734,0,0,1-.522.377,1.983,1.983,0,0,1-.509,0A7.756,7.756,0,0,1,125.31,123.254Z",
    transform: "translate(-55.778 -60.433)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2976",
    "data-name": "Path 2976",
    d: "M119.934,128.85c.185,0,.06,1.256,1.031,2.255s2.314,1,2.308,1.177-.324.212-.886.165a3.1,3.1,0,0,1-1.931-.912,2.7,2.7,0,0,1-.787-1.878C119.677,129.127,119.849,128.837,119.934,128.85Z",
    transform: "translate(-53.867 -65.592)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2977",
    "data-name": "Path 2977",
    d: "M118.414,106.554c-.145.3-1.276,0-2.645.053s-2.493.271-2.645,0c-.066-.145.159-.417.661-.661a4.39,4.39,0,0,1,1.984-.476,4.437,4.437,0,0,1,1.984.456C118.255,106.138,118.48,106.409,118.414,106.554Z",
    transform: "translate(-51.646 -57.672)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2978",
    "data-name": "Path 2978",
    d: "M135.477,108.683c-.231.238-.992-.112-1.944-.225s-1.772,0-1.931-.3c-.066-.139.086-.39.463-.6a2.724,2.724,0,0,1,1.627-.258,2.645,2.645,0,0,1,1.5.661C135.5,108.286,135.583,108.564,135.477,108.683Z",
    transform: "translate(-57.905 -58.279)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2979",
    "data-name": "Path 2979",
    d: "M98.576,118.415c-.126-.073-4.979-2.063-5.356,3.068s4.853,4.45,4.873,4.3S98.576,118.415,98.576,118.415Z",
    transform: "translate(-44.899 -61.908)",
    fill: "#ffbf9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2980",
    "data-name": "Path 2980",
    d: "M97.338,124.542a1.447,1.447,0,0,1-.251.119.919.919,0,0,1-.661-.04,2.216,2.216,0,0,1-.879-2.056,3.055,3.055,0,0,1,.344-1.263,1.031,1.031,0,0,1,.727-.661.45.45,0,0,1,.509.284c.06.145,0,.245.046.258s.112-.079.086-.291a.569.569,0,0,0-.179-.337.661.661,0,0,0-.483-.165,1.236,1.236,0,0,0-.992.727,3.081,3.081,0,0,0-.417,1.4,2.336,2.336,0,0,0,1.144,2.314.952.952,0,0,0,.826-.079C97.324,124.667,97.358,124.555,97.338,124.542Z",
    transform: "translate(-45.572 -62.726)",
    fill: "#ff9a6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2981",
    "data-name": "Path 2981",
    d: "M123.311,94.246c.86-.4-1.461-3.253-3.445-4.311-3-1.6-7.65-2.764-10.579-2.142-3.491.754-6.447,2.275-8.364,5.29a20.233,20.233,0,0,0-2.929,10.163,6.142,6.142,0,0,0,.522,3.187c.661,1.177,1.984,1.984,1.812,3.544a2.156,2.156,0,0,0,.43,1.6c.879,1.065,2.083.2,2.678-.707,1.256-1.944,1.534-4.331,1.785-6.612a15.036,15.036,0,0,0,0-4.9c-.2-.873-.549-1.706-.661-2.592a3.088,3.088,0,0,1,.529-2.539,3.2,3.2,0,0,1,.443-.39,5.362,5.362,0,0,1,5.376-.661c2.823,1.21,7.663,3.055,9.019,2.156a7.9,7.9,0,0,0,2.446-2.182Z",
    transform: "translate(-46.512 -51.625)",
    fill: "#263238"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicaltestLoading);
export default __webpack_public_path__ + "static/media/medicaltest_loading.1812b93ba8afb8a15aed4097a8a5b6cd.svg";
export { ForwardRef as ReactComponent };